import { render, staticRenderFns } from "./MakeOrderPage.vue?vue&type=template&id=470796be&scoped=true&"
import script from "./MakeOrderPage.vue?vue&type=script&lang=js&"
export * from "./MakeOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./MakeOrderPage.vue?vue&type=style&index=0&id=470796be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470796be",
  null
  
)

export default component.exports